// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file tracker/v1/tracking_domain.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ListSort, Ownership, Pagination, PaginationMeta } from "./common_pb.js";

/**
 * BindingMode is how the edge reaches the fqdn.
 *
 * @generated from enum tracker.v1.BindingMode
 */
export enum BindingMode {
  /**
   * @generated from enum value: BINDING_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The fqdn carries the edge CNAME; the edge answers every request.
   *
   * @generated from enum value: BINDING_MODE_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * The edge is routed onto a zone that keeps its own origin (its records are
   * never touched): every request the tracker does not serve — no active
   * campaign on the path, a paused one, an unknown path — falls through to
   * that origin untouched. Bound once the provider has the route in place and
   * the fqdn's record proxied; the provider is asked only after the edge has
   * learnt the mode, so binding_status stays pending a few minutes longer.
   *
   * @generated from enum value: BINDING_MODE_OVERLAY = 2;
   */
  OVERLAY = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(BindingMode)
proto3.util.setEnumType(BindingMode, "tracker.v1.BindingMode", [
  { no: 0, name: "BINDING_MODE_UNSPECIFIED" },
  { no: 1, name: "BINDING_MODE_DIRECT" },
  { no: 2, name: "BINDING_MODE_OVERLAY" },
]);

/**
 * @generated from enum tracker.v1.TrackingDomainStatus
 */
export enum TrackingDomainStatus {
  /**
   * @generated from enum value: TRACKING_DOMAIN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRACKING_DOMAIN_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: TRACKING_DOMAIN_STATUS_DISABLED = 2;
   */
  DISABLED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(TrackingDomainStatus)
proto3.util.setEnumType(TrackingDomainStatus, "tracker.v1.TrackingDomainStatus", [
  { no: 0, name: "TRACKING_DOMAIN_STATUS_UNSPECIFIED" },
  { no: 1, name: "TRACKING_DOMAIN_STATUS_ACTIVE" },
  { no: 2, name: "TRACKING_DOMAIN_STATUS_DISABLED" },
]);

/**
 * @generated from enum tracker.v1.BindingStatus
 */
export enum BindingStatus {
  /**
   * @generated from enum value: BINDING_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BINDING_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BINDING_STATUS_BOUND = 2;
   */
  BOUND = 2,

  /**
   * @generated from enum value: BINDING_STATUS_FAILED = 3;
   */
  FAILED = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(BindingStatus)
proto3.util.setEnumType(BindingStatus, "tracker.v1.BindingStatus", [
  { no: 0, name: "BINDING_STATUS_UNSPECIFIED" },
  { no: 1, name: "BINDING_STATUS_PENDING" },
  { no: 2, name: "BINDING_STATUS_BOUND" },
  { no: 3, name: "BINDING_STATUS_FAILED" },
]);

/**
 * TrackingDomain is the tracker's BINDING of a domain to its click edge. The
 * domain itself is managed by the adapter of the org's domains port
 * (domains.attach.v1, chosen by the org's Connection in console: manual DNS or
 * a domain block); binding_provider names it, binding_ref is its handle,
 * binding_records are what the fqdn must carry (the operator sets them by
 * hand on the manual adapter). binding_status mirrors the adapter's answer
 * and is refreshed every minute by the binding sync.
 *
 * @generated from message tracker.v1.TrackingDomain
 */
export class TrackingDomain extends Message<TrackingDomain> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId = "";

  /**
   * @generated from field: string fqdn = 3;
   */
  fqdn = "";

  /**
   * @generated from field: bool is_default = 4;
   */
  isDefault = false;

  /**
   * @generated from field: tracker.v1.TrackingDomainStatus status = 5;
   */
  status = TrackingDomainStatus.UNSPECIFIED;

  /**
   * @generated from field: tracker.v1.Ownership ownership = 6;
   */
  ownership?: Ownership;

  /**
   * @generated from field: string created_at = 7;
   */
  createdAt = "";

  /**
   * @generated from field: string updated_at = 8;
   */
  updatedAt = "";

  /**
   * @generated from field: string binding_provider = 9;
   */
  bindingProvider = "";

  /**
   * @generated from field: string binding_ref = 10;
   */
  bindingRef = "";

  /**
   * @generated from field: string binding_domain_id = 11;
   */
  bindingDomainId = "";

  /**
   * @generated from field: repeated tracker.v1.BindingRecord binding_records = 12;
   */
  bindingRecords: BindingRecord[] = [];

  /**
   * @generated from field: tracker.v1.BindingStatus binding_status = 13;
   */
  bindingStatus = BindingStatus.UNSPECIFIED;

  /**
   * @generated from field: string binding_error = 14;
   */
  bindingError = "";

  /**
   * @generated from field: string binding_checked_at = 15;
   */
  bindingCheckedAt = "";

  /**
   * Where a person manages the domain at the provider ("" when it has no UI).
   *
   * @generated from field: string manage_url = 16;
   */
  manageUrl = "";

  /**
   * How the edge reaches the fqdn; fixed at create.
   *
   * @generated from field: tracker.v1.BindingMode binding_mode = 17;
   */
  bindingMode = BindingMode.UNSPECIFIED;

  /**
   * How many campaigns that are not archived have their ad link on the fqdn
   * («Кампании» of доска DomainList; «Заняты» = at least one).
   *
   * @generated from field: int32 campaigns = 18;
   */
  campaigns = 0;

  /**
   * The adapter that bound it as the screen names it (domains.attach.v1
   * Describe.label of binding_provider; "" when this process has none).
   *
   * @generated from field: string binding_provider_label = 19;
   */
  bindingProviderLabel = "";

  constructor(data?: PartialMessage<TrackingDomain>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TrackingDomain";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(TrackingDomainStatus) },
    { no: 6, name: "ownership", kind: "message", T: Ownership },
    { no: 7, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "updated_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "binding_provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "binding_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "binding_domain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "binding_records", kind: "message", T: BindingRecord, repeated: true },
    { no: 13, name: "binding_status", kind: "enum", T: proto3.getEnumType(BindingStatus) },
    { no: 14, name: "binding_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "binding_checked_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "manage_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "binding_mode", kind: "enum", T: proto3.getEnumType(BindingMode) },
    { no: 18, name: "campaigns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 19, name: "binding_provider_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackingDomain {
    return new TrackingDomain().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackingDomain {
    return new TrackingDomain().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackingDomain {
    return new TrackingDomain().fromJsonString(jsonString, options);
  }

  static equals(a: TrackingDomain | PlainMessage<TrackingDomain> | undefined, b: TrackingDomain | PlainMessage<TrackingDomain> | undefined): boolean {
    return proto3.util.equals(TrackingDomain, a, b);
  }
}

/**
 * One campaign whose ad link lives on a domain (доска DomainDrawer, «Кампании
 * на домене»): what the buyer opens, and the address it answers on.
 *
 * @generated from message tracker.v1.DomainCampaign
 */
export class DomainCampaign extends Message<DomainCampaign> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * ACTIVE | PAUSED | DRAFT (archived campaigns are not listed).
   *
   * @generated from field: string status = 3;
   */
  status = "";

  /**
   * @generated from field: string public_path = 4;
   */
  publicPath = "";

  constructor(data?: PartialMessage<DomainCampaign>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DomainCampaign";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "public_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DomainCampaign {
    return new DomainCampaign().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DomainCampaign {
    return new DomainCampaign().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DomainCampaign {
    return new DomainCampaign().fromJsonString(jsonString, options);
  }

  static equals(a: DomainCampaign | PlainMessage<DomainCampaign> | undefined, b: DomainCampaign | PlainMessage<DomainCampaign> | undefined): boolean {
    return proto3.util.equals(DomainCampaign, a, b);
  }
}

/**
 * The domain list's chips (доска DomainList: Все · Заняты · Свободны ·
 * Проблемы), counted by the server over every domain matching the search.
 *
 * @generated from message tracker.v1.TrackingDomainCounts
 */
export class TrackingDomainCounts extends Message<TrackingDomainCounts> {
  /**
   * @generated from field: int32 all = 1;
   */
  all = 0;

  /**
   * At least one campaign that is not archived.
   *
   * @generated from field: int32 busy = 2;
   */
  busy = 0;

  /**
   * @generated from field: int32 free = 3;
   */
  free = 0;

  /**
   * Switched on, but the binding is not bound (pending or failed): a campaign
   * on it cannot start.
   *
   * @generated from field: int32 problems = 4;
   */
  problems = 0;

  constructor(data?: PartialMessage<TrackingDomainCounts>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.TrackingDomainCounts";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "all", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "busy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "free", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "problems", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackingDomainCounts {
    return new TrackingDomainCounts().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackingDomainCounts {
    return new TrackingDomainCounts().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackingDomainCounts {
    return new TrackingDomainCounts().fromJsonString(jsonString, options);
  }

  static equals(a: TrackingDomainCounts | PlainMessage<TrackingDomainCounts> | undefined, b: TrackingDomainCounts | PlainMessage<TrackingDomainCounts> | undefined): boolean {
    return proto3.util.equals(TrackingDomainCounts, a, b);
  }
}

/**
 * BindingRecord is a DNS record the fqdn must carry for the edge.
 *
 * @generated from message tracker.v1.BindingRecord
 */
export class BindingRecord extends Message<BindingRecord> {
  /**
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * @generated from field: string type = 2;
   */
  type = "";

  /**
   * @generated from field: string content = 3;
   */
  content = "";

  /**
   * @generated from field: bool proxied = 4;
   */
  proxied = false;

  constructor(data?: PartialMessage<BindingRecord>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.BindingRecord";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "proxied", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BindingRecord {
    return new BindingRecord().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BindingRecord {
    return new BindingRecord().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BindingRecord {
    return new BindingRecord().fromJsonString(jsonString, options);
  }

  static equals(a: BindingRecord | PlainMessage<BindingRecord> | undefined, b: BindingRecord | PlainMessage<BindingRecord> | undefined): boolean {
    return proto3.util.equals(BindingRecord, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListTrackingDomainsRequest
 */
export class ListTrackingDomainsRequest extends Message<ListTrackingDomainsRequest> {
  /**
   * @generated from field: tracker.v1.Pagination pagination = 1;
   */
  pagination?: Pagination;

  /**
   * Part of the fqdn, case-insensitive.
   *
   * @generated from field: string search = 2;
   */
  search = "";

  /**
   * Domains by their own id — a screen naming the domains it already shows.
   *
   * @generated from field: repeated string ids = 3;
   */
  ids: string[] = [];

  /**
   * fqdn | status | binding_status | binding_checked_at | created_at | campaigns (default: the workspace's
   * default domain first, then newest first).
   *
   * @generated from field: tracker.v1.ListSort sort = 4;
   */
  sort?: ListSort;

  /**
   * busy | free | problems (TrackingDomainCounts); "" = every domain.
   *
   * @generated from field: string usage = 5;
   */
  usage = "";

  constructor(data?: PartialMessage<ListTrackingDomainsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListTrackingDomainsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: Pagination },
    { no: 2, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "sort", kind: "message", T: ListSort },
    { no: 5, name: "usage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTrackingDomainsRequest {
    return new ListTrackingDomainsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTrackingDomainsRequest {
    return new ListTrackingDomainsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTrackingDomainsRequest {
    return new ListTrackingDomainsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListTrackingDomainsRequest | PlainMessage<ListTrackingDomainsRequest> | undefined, b: ListTrackingDomainsRequest | PlainMessage<ListTrackingDomainsRequest> | undefined): boolean {
    return proto3.util.equals(ListTrackingDomainsRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.ListTrackingDomainsResponse
 */
export class ListTrackingDomainsResponse extends Message<ListTrackingDomainsResponse> {
  /**
   * @generated from field: repeated tracker.v1.TrackingDomain items = 1;
   */
  items: TrackingDomain[] = [];

  /**
   * @generated from field: tracker.v1.PaginationMeta pagination = 2;
   */
  pagination?: PaginationMeta;

  /**
   * The chips, over the search and regardless of `usage`.
   *
   * @generated from field: tracker.v1.TrackingDomainCounts counts = 3;
   */
  counts?: TrackingDomainCounts;

  constructor(data?: PartialMessage<ListTrackingDomainsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.ListTrackingDomainsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: TrackingDomain, repeated: true },
    { no: 2, name: "pagination", kind: "message", T: PaginationMeta },
    { no: 3, name: "counts", kind: "message", T: TrackingDomainCounts },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTrackingDomainsResponse {
    return new ListTrackingDomainsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTrackingDomainsResponse {
    return new ListTrackingDomainsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTrackingDomainsResponse {
    return new ListTrackingDomainsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTrackingDomainsResponse | PlainMessage<ListTrackingDomainsResponse> | undefined, b: ListTrackingDomainsResponse | PlainMessage<ListTrackingDomainsResponse> | undefined): boolean {
    return proto3.util.equals(ListTrackingDomainsResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTrackingDomainRequest
 */
export class GetTrackingDomainRequest extends Message<GetTrackingDomainRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrackingDomainRequest {
    return new GetTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrackingDomainRequest {
    return new GetTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrackingDomainRequest {
    return new GetTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrackingDomainRequest | PlainMessage<GetTrackingDomainRequest> | undefined, b: GetTrackingDomainRequest | PlainMessage<GetTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(GetTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetTrackingDomainResponse
 */
export class GetTrackingDomainResponse extends Message<GetTrackingDomainResponse> {
  /**
   * @generated from field: tracker.v1.TrackingDomain domain = 1;
   */
  domain?: TrackingDomain;

  /**
   * The campaigns on the fqdn that are not archived, by name, at most 100.
   *
   * @generated from field: repeated tracker.v1.DomainCampaign campaigns = 2;
   */
  campaigns: DomainCampaign[] = [];

  constructor(data?: PartialMessage<GetTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "message", T: TrackingDomain },
    { no: 2, name: "campaigns", kind: "message", T: DomainCampaign, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetTrackingDomainResponse {
    return new GetTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetTrackingDomainResponse {
    return new GetTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetTrackingDomainResponse {
    return new GetTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetTrackingDomainResponse | PlainMessage<GetTrackingDomainResponse> | undefined, b: GetTrackingDomainResponse | PlainMessage<GetTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(GetTrackingDomainResponse, a, b);
  }
}

/**
 * CreateTrackingDomain asks the domain provider to bind the fqdn to the
 * edge and records the binding. The row starts pending and flips bound when
 * the provider reports the records live.
 *
 * @generated from message tracker.v1.CreateTrackingDomainRequest
 */
export class CreateTrackingDomainRequest extends Message<CreateTrackingDomainRequest> {
  /**
   * @generated from field: string fqdn = 1;
   */
  fqdn = "";

  /**
   * @generated from field: bool is_default = 2;
   */
  isDefault = false;

  /**
   * Unspecified = direct.
   *
   * @generated from field: tracker.v1.BindingMode binding_mode = 3;
   */
  bindingMode = BindingMode.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "fqdn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "binding_mode", kind: "enum", T: proto3.getEnumType(BindingMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTrackingDomainRequest {
    return new CreateTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTrackingDomainRequest {
    return new CreateTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTrackingDomainRequest {
    return new CreateTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTrackingDomainRequest | PlainMessage<CreateTrackingDomainRequest> | undefined, b: CreateTrackingDomainRequest | PlainMessage<CreateTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(CreateTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.CreateTrackingDomainResponse
 */
export class CreateTrackingDomainResponse extends Message<CreateTrackingDomainResponse> {
  /**
   * @generated from field: tracker.v1.TrackingDomain domain = 1;
   */
  domain?: TrackingDomain;

  constructor(data?: PartialMessage<CreateTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.CreateTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "message", T: TrackingDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTrackingDomainResponse {
    return new CreateTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTrackingDomainResponse {
    return new CreateTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTrackingDomainResponse {
    return new CreateTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTrackingDomainResponse | PlainMessage<CreateTrackingDomainResponse> | undefined, b: CreateTrackingDomainResponse | PlainMessage<CreateTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(CreateTrackingDomainResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateTrackingDomainRequest
 */
export class UpdateTrackingDomainRequest extends Message<UpdateTrackingDomainRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: optional tracker.v1.TrackingDomainStatus status = 2;
   */
  status?: TrackingDomainStatus;

  constructor(data?: PartialMessage<UpdateTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(TrackingDomainStatus), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTrackingDomainRequest {
    return new UpdateTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTrackingDomainRequest {
    return new UpdateTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTrackingDomainRequest {
    return new UpdateTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTrackingDomainRequest | PlainMessage<UpdateTrackingDomainRequest> | undefined, b: UpdateTrackingDomainRequest | PlainMessage<UpdateTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(UpdateTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.UpdateTrackingDomainResponse
 */
export class UpdateTrackingDomainResponse extends Message<UpdateTrackingDomainResponse> {
  /**
   * @generated from field: tracker.v1.TrackingDomain domain = 1;
   */
  domain?: TrackingDomain;

  constructor(data?: PartialMessage<UpdateTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.UpdateTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "message", T: TrackingDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateTrackingDomainResponse {
    return new UpdateTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateTrackingDomainResponse {
    return new UpdateTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateTrackingDomainResponse {
    return new UpdateTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateTrackingDomainResponse | PlainMessage<UpdateTrackingDomainResponse> | undefined, b: UpdateTrackingDomainResponse | PlainMessage<UpdateTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(UpdateTrackingDomainResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteTrackingDomainRequest
 */
export class DeleteTrackingDomainRequest extends Message<DeleteTrackingDomainRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<DeleteTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTrackingDomainRequest {
    return new DeleteTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTrackingDomainRequest {
    return new DeleteTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTrackingDomainRequest {
    return new DeleteTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTrackingDomainRequest | PlainMessage<DeleteTrackingDomainRequest> | undefined, b: DeleteTrackingDomainRequest | PlainMessage<DeleteTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(DeleteTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.DeleteTrackingDomainResponse
 */
export class DeleteTrackingDomainResponse extends Message<DeleteTrackingDomainResponse> {
  constructor(data?: PartialMessage<DeleteTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DeleteTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteTrackingDomainResponse {
    return new DeleteTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteTrackingDomainResponse {
    return new DeleteTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteTrackingDomainResponse {
    return new DeleteTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteTrackingDomainResponse | PlainMessage<DeleteTrackingDomainResponse> | undefined, b: DeleteTrackingDomainResponse | PlainMessage<DeleteTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(DeleteTrackingDomainResponse, a, b);
  }
}

/**
 * @generated from message tracker.v1.SetDefaultTrackingDomainRequest
 */
export class SetDefaultTrackingDomainRequest extends Message<SetDefaultTrackingDomainRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SetDefaultTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SetDefaultTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultTrackingDomainRequest {
    return new SetDefaultTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultTrackingDomainRequest {
    return new SetDefaultTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultTrackingDomainRequest {
    return new SetDefaultTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultTrackingDomainRequest | PlainMessage<SetDefaultTrackingDomainRequest> | undefined, b: SetDefaultTrackingDomainRequest | PlainMessage<SetDefaultTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(SetDefaultTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SetDefaultTrackingDomainResponse
 */
export class SetDefaultTrackingDomainResponse extends Message<SetDefaultTrackingDomainResponse> {
  /**
   * @generated from field: tracker.v1.TrackingDomain domain = 1;
   */
  domain?: TrackingDomain;

  constructor(data?: PartialMessage<SetDefaultTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SetDefaultTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "message", T: TrackingDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SetDefaultTrackingDomainResponse {
    return new SetDefaultTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SetDefaultTrackingDomainResponse {
    return new SetDefaultTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SetDefaultTrackingDomainResponse {
    return new SetDefaultTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SetDefaultTrackingDomainResponse | PlainMessage<SetDefaultTrackingDomainResponse> | undefined, b: SetDefaultTrackingDomainResponse | PlainMessage<SetDefaultTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(SetDefaultTrackingDomainResponse, a, b);
  }
}

/**
 * SyncTrackingDomain re-checks the binding with the provider now instead of
 * waiting for the minute sync.
 *
 * @generated from message tracker.v1.SyncTrackingDomainRequest
 */
export class SyncTrackingDomainRequest extends Message<SyncTrackingDomainRequest> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<SyncTrackingDomainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SyncTrackingDomainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SyncTrackingDomainRequest {
    return new SyncTrackingDomainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SyncTrackingDomainRequest {
    return new SyncTrackingDomainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SyncTrackingDomainRequest {
    return new SyncTrackingDomainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SyncTrackingDomainRequest | PlainMessage<SyncTrackingDomainRequest> | undefined, b: SyncTrackingDomainRequest | PlainMessage<SyncTrackingDomainRequest> | undefined): boolean {
    return proto3.util.equals(SyncTrackingDomainRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.SyncTrackingDomainResponse
 */
export class SyncTrackingDomainResponse extends Message<SyncTrackingDomainResponse> {
  /**
   * @generated from field: tracker.v1.TrackingDomain domain = 1;
   */
  domain?: TrackingDomain;

  constructor(data?: PartialMessage<SyncTrackingDomainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.SyncTrackingDomainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "domain", kind: "message", T: TrackingDomain },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SyncTrackingDomainResponse {
    return new SyncTrackingDomainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SyncTrackingDomainResponse {
    return new SyncTrackingDomainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SyncTrackingDomainResponse {
    return new SyncTrackingDomainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SyncTrackingDomainResponse | PlainMessage<SyncTrackingDomainResponse> | undefined, b: SyncTrackingDomainResponse | PlainMessage<SyncTrackingDomainResponse> | undefined): boolean {
    return proto3.util.equals(SyncTrackingDomainResponse, a, b);
  }
}

/**
 * DomainPort is how the org's `domains` port (capability domains.attach.v1)
 * attaches a new domain now, as the tracker resolves it: the adapter that
 * answers, what it can do, what a person sets by hand on the manual adapter,
 * and the caller's free domains at an adapter that keeps owners. A port the
 * tracker cannot use is a refusal with ErrorInfo.reason instead
 * (adapter_not_wired, connector_unavailable) or Unavailable (console down).
 *
 * @generated from message tracker.v1.DomainPort
 */
export class DomainPort extends Message<DomainPort> {
  /**
   * "native" (a block attaches the name itself) | "manual" (a person sets
   * the records, the tracker verifies them by DNS).
   *
   * @generated from field: string kind = 1;
   */
  kind = "";

  /**
   * The adapter's name for the screen (Describe.label).
   *
   * @generated from field: string label = 2;
   */
  label = "";

  /**
   * Extended capabilities: overlay, owner_pool, manage_url, register.
   *
   * @generated from field: repeated string extended = 3;
   */
  extended: string[] = [];

  /**
   * What a direct domain must carry: the manual adapter shows these, a
   * native one writes them itself.
   *
   * @generated from field: repeated tracker.v1.BindingRecord records = 4;
   */
  records: BindingRecord[] = [];

  /**
   * The caller's own domains at the adapter that no workspace binds yet
   * (extended owner_pool) — what the attach form can still connect — at most
   * 50 in the order the adapter hands them out.
   *
   * @generated from field: repeated string free_domains = 5;
   */
  freeDomains: string[] = [];

  /**
   * Where a person gets and manages domains at the adapter ("" = no screen).
   *
   * @generated from field: string domains_url = 6;
   */
  domainsUrl = "";

  constructor(data?: PartialMessage<DomainPort>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.DomainPort";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "extended", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "records", kind: "message", T: BindingRecord, repeated: true },
    { no: 5, name: "free_domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "domains_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DomainPort {
    return new DomainPort().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DomainPort {
    return new DomainPort().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DomainPort {
    return new DomainPort().fromJsonString(jsonString, options);
  }

  static equals(a: DomainPort | PlainMessage<DomainPort> | undefined, b: DomainPort | PlainMessage<DomainPort> | undefined): boolean {
    return proto3.util.equals(DomainPort, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetDomainPortRequest
 */
export class GetDomainPortRequest extends Message<GetDomainPortRequest> {
  constructor(data?: PartialMessage<GetDomainPortRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetDomainPortRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDomainPortRequest {
    return new GetDomainPortRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDomainPortRequest {
    return new GetDomainPortRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDomainPortRequest {
    return new GetDomainPortRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDomainPortRequest | PlainMessage<GetDomainPortRequest> | undefined, b: GetDomainPortRequest | PlainMessage<GetDomainPortRequest> | undefined): boolean {
    return proto3.util.equals(GetDomainPortRequest, a, b);
  }
}

/**
 * @generated from message tracker.v1.GetDomainPortResponse
 */
export class GetDomainPortResponse extends Message<GetDomainPortResponse> {
  /**
   * @generated from field: tracker.v1.DomainPort port = 1;
   */
  port?: DomainPort;

  constructor(data?: PartialMessage<GetDomainPortResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "tracker.v1.GetDomainPortResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "port", kind: "message", T: DomainPort },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDomainPortResponse {
    return new GetDomainPortResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDomainPortResponse {
    return new GetDomainPortResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDomainPortResponse {
    return new GetDomainPortResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDomainPortResponse | PlainMessage<GetDomainPortResponse> | undefined, b: GetDomainPortResponse | PlainMessage<GetDomainPortResponse> | undefined): boolean {
    return proto3.util.equals(GetDomainPortResponse, a, b);
  }
}

